<template>
  <v-text-field
    v-bind="$input"
     v-on="$listeners"
    :label="$attrs.label"    
    :disabled="disabled"
    :readonly="readonly"
    v-model="displayValue"
    @blur="focus_lost">  
  </v-text-field>  
</template>


<script>

  export default {
    props: {    
      value: { type: [String, Number], default: "" },      
      disabled: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false }
    },

    data() {
      return {
        cif: '',
      }
    },

    computed: {
      displayValue: {
        get: function() {         
          return this.value;
        },
        
        set: function(modifiedValue) {         
          this.$emit("input", modifiedValue);
        }
      }
    },
    
    methods: {
      focus_lost(event) {     
        let ctrl= document.getElementById(event.srcElement.id);
        if (ctrl.value=='') return;        
       
        // valido cif/dni/nie
        if (!this.valida_cif(ctrl.value)) {       
          this.$root.$alert.open('NIF / CIF Incorrecto ' + ctrl.value, 'error', 1500);          
          setTimeout(function() { ctrl.focus(); }, 1);
        }
        //enviamos dato limpio
        this.$emit("input", this.cif);
      },

      // 
      valida_cif(nif) {
        nif = nif.toUpperCase().replace(/[_\W\s]+/g, '');
        this.cif=nif;
        if(/^(\d|[XYZ])\d{7}[A-Z]$/.test(nif)) {
            let num = nif.match(/\d+/);
            num = (nif[0]!='Z'? nif[0]!='Y'? 0: 1: 2)+num;
            if(nif[8]=='TRWAGMYFPDXBNJZSQVHLCKE'[num%23]) {
                return /^\d/.test(nif)? 'DNI': 'NIE';
            }
        }
        else if(/^[ABCDEFGHJKLMNPQRSUVW]\d{7}[\dA-J]$/.test(nif)) {
            var par = 0; 
            var non = 0;          
                    
            for (let zz=2;zz<8;zz+=2) {
                par = par+parseInt(nif.charAt(zz));
            }                
            for (let zz=1;zz<9;zz+=2) {
                let nn = 2*parseInt(nif.charAt(zz));
                if (nn > 9) nn = 1+(nn-10);
                non = non+nn;
            }    
            let parcial = par + non;
            let control = (10 - ( parcial % 10));
            if (control==10) control=0;              
            return (String(control)==nif.charAt(8))
        }

        this.$root.$alert.open();
        return false;
      },
    }
  };

</script>

